export default __webpack_public_path__ + "static/media/teamMember4.45cfbb10.png";